import { api } from './client';

// tsconfig has erasableSyntaxOnly, so this mirrors the backend enum as a string literal union rather than `enum`
export type SeasonStatus = 'PREPARING' | 'GROWING' | 'NEAR_HARVEST' | 'HARVESTED' | 'FINISHED' | 'AT_RISK';

export interface BackendSeason {
  _id: string;
  farmerId: string;
  htxId: string;
  fieldId: string;
  code?: string;
  name: string;
  mainCrop: string;
  variety?: string;
  startDate: string;
  endDate?: string;
  expectedYield: number;
  unit: string;
  materialNorm?: string;
  status: SeasonStatus;
  /** Optional link to admin/Engineer-curated Crop master data — set by HTX
   * staff before applying a CultivationProcess to this season. */
  cropId?: string;
  // schema uses timestamps: true, so Mongoose adds these even though the class doesn't declare them
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateSeasonPayload {
  farmerId: string;
  fieldId: string;
  code?: string;
  name: string;
  mainCrop: string;
  cropId?: string;
  variety?: string;
  startDate: string;
  endDate?: string;
  expectedYield: number;
  unit: string;
  materialNorm?: string;
}

export interface UpdateSeasonPayload {
  name?: string;
  endDate?: string;
  expectedYield?: number;
  status?: SeasonStatus;
  materialNorm?: string;
  cropId?: string;
}

export async function createSeason(data: CreateSeasonPayload): Promise<BackendSeason> {
  return api.post<BackendSeason>('/seasons', data);
}

export async function updateSeason(id: string, data: UpdateSeasonPayload): Promise<BackendSeason> {
  return api.patch<BackendSeason>(`/seasons/${id}`, data);
}

export async function getSeasonById(id: string): Promise<BackendSeason> {
  return api.get<BackendSeason>(`/seasons/${id}`);
}

export async function listSeasonsByFarmer(farmerId: string): Promise<BackendSeason[]> {
  return api.get<BackendSeason[]>(`/seasons/farmers/${farmerId}`);
}

export async function listSeasonsByField(fieldId: string): Promise<BackendSeason[]> {
  return api.get<BackendSeason[]>(`/seasons/fields/${fieldId}`);
}

export async function listSeasonsByHtx(htxId: string): Promise<BackendSeason[]> {
  return api.get<BackendSeason[]>(`/seasons/htx/${htxId}`);
}
